"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const surveyHelperNew = __importStar(require("evolution-common/lib/utils/helpers"));
const Survey_1 = require("../../actions/Survey");
const LoadingPage_1 = __importDefault(require("chaire-lib-frontend/lib/components/pages/LoadingPage"));
const WithPreferencesHoc_1 = require("../hoc/WithPreferencesHoc");
const InterviewContext_1 = require("../../contexts/InterviewContext");
const Survey_2 = __importDefault(require("../pageParts/Survey"));
const SurveyContext_1 = require("../../contexts/SurveyContext");
const react_i18next_1 = require("react-i18next");
const SurveyParticipant = () => {
    // Get state selectors and other hooks
    const interview = (0, react_redux_1.useSelector)((state) => state.survey.interview);
    const interviewLoaded = (0, react_redux_1.useSelector)((state) => state.survey.interviewLoaded);
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_1.useNavigate)();
    const { sectionShortname: pathSectionShortname, uuid: surveyUuid } = (0, react_router_1.useParams)();
    const { sections } = (0, react_1.useContext)(SurveyContext_1.SurveyContext);
    const { i18n } = (0, react_i18next_1.useTranslation)();
    const { state: interviewContext } = react_1.default.useContext(InterviewContext_1.InterviewContext);
    const startUpdateInterviewAction = react_1.default.useCallback((data, callback) => dispatch((0, Survey_1.startUpdateInterview)(Object.assign(Object.assign({}, data), { gotoFunction: navigate }), callback)), [navigate]);
    const startAddGroupedObjectsAction = react_1.default.useCallback((newObjectsCount, insertSequence, path, attributes, callback, returnOnly) => dispatch((0, Survey_1.startAddGroupedObjects)(newObjectsCount, insertSequence, path, attributes, callback, returnOnly)), []);
    const startRemoveGroupedObjectsAction = react_1.default.useCallback((paths, callback, returnOnly) => dispatch((0, Survey_1.startRemoveGroupedObjects)(paths, callback, returnOnly)), []);
    const startNavigateAction = react_1.default.useCallback((options) => dispatch((0, Survey_1.startNavigate)(Object.assign(Object.assign({}, options), { gotoFunction: navigate }))), [dispatch]);
    // Initialize navigation service before setting the interview in the next useEffect
    react_1.default.useEffect(() => {
        dispatch((0, Survey_1.initNavigationService)(sections));
    }, [sections, dispatch]);
    react_1.default.useEffect(() => {
        const startSetInterviewAction = (sectionShortname, surveyUuid, preFilledResponse) => dispatch((0, Survey_1.startSetInterview)(sectionShortname, surveyUuid, navigate, preFilledResponse));
        startSetInterviewAction(pathSectionShortname, surveyUuid, interviewContext &&
            interviewContext.status === 'entering' &&
            Object.keys(interviewContext.response).length > 0
            ? interviewContext.response
            : undefined);
    }, [surveyUuid, dispatch]); // Re-run when survey uuid changes
    react_1.default.useEffect(() => {
        const languageChange = (language) => {
            startUpdateInterviewAction({ userAction: { type: 'languageChange', language } });
        };
        i18n.on('languageChanged', languageChange);
        return () => {
            i18n.off('languageChanged', languageChange);
        };
    }, [startUpdateInterviewAction]);
    // FIXME See if we can use react Suspense instead of this logic for the loading page (https://react.dev/reference/react/Suspense)
    if (!interviewLoaded || !interview || !interview.sectionLoaded) {
        surveyHelperNew.devLog('%c interview not yet available or loading', 'background: rgba(0,0,0,0.1);');
        return react_1.default.createElement(LoadingPage_1.default, null);
    }
    return (react_1.default.createElement(Survey_2.default, { startUpdateInterview: startUpdateInterviewAction, startAddGroupedObjects: startAddGroupedObjectsAction, startRemoveGroupedObjects: startRemoveGroupedObjectsAction, startNavigate: startNavigateAction, interview: interview }));
};
exports.default = (0, WithPreferencesHoc_1.withPreferencesHOC)(SurveyParticipant);
//# sourceMappingURL=SurveyParticipant.js.map